import API from '@/services/api/api'
import axios from 'axios'

const getMenues = async function(moduleId) {
    try {
        let response = await axios.get(API.GET_MENU_USER, {
            params: {
                g_module_id: moduleId,
            },
        })
        return response.data
    } catch (error) {
        return error.response.data
    }
}

export default { getMenues }
